interface Array<T> {
  max(): T;
  maxOrDefault(defaultValue: T): T;
  first(): T;
  firstOrDefault(): T | null;
  distinct(): T[];
  replaceItem(newItem: T, keySelector: Function): T[];
}

Array.prototype.max = function<T>(): T {
  if (!this || this.length < 1) {
    throw new Error('Cannot find max value of empty or null');
  }

  let max = this[0];

  for (const value of this) {
    if (value > max) {
      max = value;
    }
  }

  return max;
};

Array.prototype.maxOrDefault = function<T>(defaultValue?: T): T {
  if (!this || this.length < 1) {
    return defaultValue;
  }

  return this.max();
};

Array.prototype.first = function<T>(): T {
  return this[0];
};

Array.prototype.firstOrDefault = function<T>(): T | null {
  if (!this || this.length < 1) {
    return null;
  }

  return this.first();
};

Array.prototype.distinct = function<T>(): T[] {
  if (!this) {
    throw { message: 'Cannot find distinct values of null.' };
  }

  return this.filter((a: T, i: number, A: T[]) => A.indexOf(a) === i);
};

Array.prototype.replaceItem = function<T>(newItem: T, keySelector: Function): T[] {
  const oldItem = this.find((x: T) => keySelector(x) === keySelector(newItem));
  const index = this.indexOf(oldItem);

  this[index] = newItem;

  return this;
};
